const STATE_PENDING = "P";
const STATE_IN_EXECUTION = "X";
const STATE_FINISHED = "F";
const STATE_CANCELLED = "C";

const STATE_PENDING_NAME = "Pendiente";
const STATE_IN_EXECUTION_NAME = "En Ejecución";
const STATE_FINISHED_NAME = "Finalizada";
const STATE_CANCELLED_NAME = "Cancelada";

export const ProductionOrderStates = {
  STATE_PENDING: STATE_PENDING,
  STATE_IN_EXECUTION: STATE_IN_EXECUTION,
  STATE_FINISHED: STATE_FINISHED,
  STATE_CANCELLED: STATE_CANCELLED,
  STATE_PENDING_NAME: STATE_PENDING_NAME,
  STATE_IN_EXECUTION_NAME: STATE_IN_EXECUTION_NAME,
  STATE_FINISHED_NAME: STATE_FINISHED_NAME,
  STATE_CANCELLED_NAME: STATE_CANCELLED_NAME,
};

export default ProductionOrderStates;